module.exports = __webpack_public_path__ + "img/bg2.6d656835.png";